// Day js
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
// Translation
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import { initReactI18next, useTranslation } from "react-i18next";
// React
import { useEffect } from "react";
// React router dom
import {
  Route,
  Routes,
  useLocation,
  useNavigationType,
} from "react-router-dom";
// Pages
import Home from "./pages/Home/Home";
import DeviceViewer from "./pages/DeviceViewer/DeviceViewer";
import DeviceRegistration from "./pages/DeviceRegistration/DeviceRegistration";
import DeviceList from "./pages/DeviceList/DeviceList";
import SoftwareMapping from "./pages/SoftwareMapping/SoftwareMapping";
import Error from "./pages/Error/Error";
import InProgress from "./pages/InProgress/InProgress";
//Implementation Guide
import { toPublicUrl } from "./services/PublicUrl";
import ImplementationGuidePage from "./pages/ImplementationGuide/ImplementationGuidePage";

require("dayjs/locale/fr");

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    supportedLngs: ["fr", "en"],
    backend: {
      loadPath: toPublicUrl("/locales/{{lng}}/{{ns}}.json"),
    },
  });

dayjs.extend(relativeTime);
dayjs.locale(i18n.language);

function App() {
  const action = useNavigationType();
  const location = useLocation();
  const pathname = location.pathname;

  useTranslation();

  useEffect(() => {
    if (action !== "POP") {
      window.scrollTo(0, 0);
    }
  }, [action, pathname]);

  useEffect(() => {
    let title = "";
    let metaDescription = "";

    switch (pathname) {
      case "/":
      case "/Vulcan":
      case "/Home":
      case "/Vulcan/Home":
        title = "Home page";
        metaDescription = "";
        break;
      case "/MaterialList":
        title = "Hardware";
        metaDescription = "";
        break;
      case "/MaterialCategories":
        title = "Material Categories";
        metaDescription = "";
        break;
      case "/SoftwareList":
        title = "Software";
        metaDescription = "";
        break;
      case "/SoftwareMapping":
        title = "Information system map";
        metaDescription = "";
        break;
      case "/SoftwareEdition":
        title = "Software Edition";
        metaDescription = "";
        break;
      case "/SoftwareCategories":
        title = "Software Categories";
        metaDescription = "";
        break;
      case "/SoftwareRegistration":
        title = "Software Registration";
        metaDescription = "";
        break;
      case "/MaterialRegistration":
        title = "Material Registration";
        metaDescription = "";
        break;
      case "/Error":
        title = "Oops !";
        metaDescription = "";
        break;
      case "/InProgress":
        title = "Coming Soon";
        metaDescription = "";
        break;
      case "/ImplementationGuide":
      case "/Vulcan/ImplementationGuide":
        title = "FHIR Implementation Guide";
        metaDescription = "";
        break;
    }

    if (pathname.startsWith("/SoftwareViewer/")) {
      title = "Software Details";
    }

    if (pathname.startsWith("/MaterialViewer/")) {
      title = "Material Details";
    }

    if (title) {
      document.title = title;
    }

    if (metaDescription) {
      const metaDescriptionTag: HTMLMetaElement | null = document.querySelector(
        'head > meta[name="description"]',
      );
      if (metaDescriptionTag) {
        metaDescriptionTag.content = metaDescription;
      }
    }
  }, [pathname]);

  return (
    <Routes>
      <Route index element={<Home />} />
      <Route path="/" element={<Home />} />
      <Route path="/Home" element={<Home />} />
      <Route path="/Vulcan" element={<Home />} />
      <Route path="/Vulcan/Home" element={<Home />} />
      <Route path="/MaterialList" element={<DeviceList kind="material" />} />
      <Route path="/MaterialCategories" element={<InProgress />} />
      <Route path="/SoftwareList" element={<DeviceList kind="software" />} />
      <Route
        path="/SoftwareMapping"
        element={<SoftwareMapping />}
      />
      <Route
        path="/SoftwareViewer/:softwareId"
        element={<DeviceViewer kind="software" />}
      />
      <Route
        path="/MaterialViewer/:deviceId"
        element={<DeviceViewer kind="material" />}
      />
      <Route path="/SoftwareEdition/:softwareId" element={<InProgress />} />
      <Route path="/SoftwareCategories" element={<InProgress />} />
      <Route
        path="/SoftwareRegistration"
        element={<DeviceRegistration kind="software" />}
      />
      <Route
        path="/MaterialRegistration"
        element={<DeviceRegistration kind="material" />}
      />
      <Route path="/Error" element={<Error />} />
      <Route
        path="/ImplementationGuide"
        element={<ImplementationGuidePage />}
      />
      <Route path="/InProgress" element={<InProgress />} />
      <Route path="*" element={<Error notFound />} />
    </Routes>
  );
}

export default App;
